export interface Category {
  name: string;
  displayName: string;
  url: string;
}

export const categories: Category[] = [
  { name: 'Shoes', displayName: 'Shoes', url: 'https://kaspreadsheet.com/category-911-Shoes.html' },
  { name: 'Hoodies/Sweaters', displayName: 'Hoodies/Sweaters', url: 'https://kaspreadsheet.com/category-912-Hoodies%2FSweaters.html' },
  { name: 'T-Shirts', displayName: 'T-Shirts', url: 'https://kaspreadsheet.com/category-913-T-Shirts.html' },
  { name: 'Jackets', displayName: 'Jackets', url: 'https://kaspreadsheet.com/category-914-Jackets.html' },
  { name: 'Pants/Shorts', displayName: 'Pants/Shorts', url: 'https://kaspreadsheet.com/category-915-Pants%2FShorts.html' },
  { name: 'Headwear', displayName: 'Headwear', url: 'https://kaspreadsheet.com/category-916-Headwear.html' },
  { name: 'Sets', displayName: 'Sets', url: 'https://kaspreadsheet.com/category-917-Sets.html' },
  { name: 'Underwear', displayName: 'Underwear/Underpants', url: 'https://kaspreadsheet.com/category-918-underwear%2Funderpants.html' },
  { name: 'Jersey', displayName: 'Jersey', url: 'https://kaspreadsheet.com/category-919-Jersey.html' },
  { name: 'Accessories', displayName: 'Accessories', url: 'https://kaspreadsheet.com/category-920-Accessories.html' },
  { name: 'Bags', displayName: 'Bags', url: 'https://kaspreadsheet.com/category-921-Bags.html' },
  { name: 'Belts', displayName: 'Belts', url: 'https://kaspreadsheet.com/search-922/name/Bags.html' },
  { name: 'Perfumes', displayName: 'Perfumes', url: 'https://kaspreadsheet.com/search-923/name/Bags.html' },
  { name: 'OtherStuff', displayName: 'Other Stuff', url: 'https://kaspreadsheet.com/search-924/name/Bags.html' },
];